module.exports = __webpack_public_path__ + "static/monetize-2-4f130cd45c351c91ed9acb3012830036.png";